/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Directive, ElementRef, NgZone, Optional, Self } from '@angular/core';
import { FocusManager } from '../services/focus-manager';
import { BaseFocusThenScrollDirective, Orientation } from './base-focus-then-scroll.directive';
import { ContinuousNavigationMotionDirective } from './continuous-navigation-motion.directive';

@Directive({
    selector: `
        [nvSpatialNavigationVirtualScroll],
        cdk-virtual-scroll-viewport[nvSpatialNavigationContainer][navigateAction="focus"],
        cdk-virtual-scroll-viewport[nvSpatialNavigationGroup][navigateAction="focus"]
    `,
    standalone: true
})
export class SpatialNavigationVirtualScrollDirective extends BaseFocusThenScrollDirective {
    constructor(
        private scroller: CdkVirtualScrollViewport,
        focusManager: FocusManager,
        elementRef: ElementRef<HTMLElement>,
        ngZone: NgZone,
        @Optional() @Self() continuousNavigationMotion: ContinuousNavigationMotionDirective | null
    ) {
        super(elementRef, focusManager, ngZone, continuousNavigationMotion);
    }

    protected get orientation(): Orientation {
        return this.scroller.orientation;
    }

    protected get scrollerElement(): HTMLElement {
        return this.scroller.getElementRef().nativeElement;
    }
}
